import {inject, Injectable} from '@angular/core';
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {BannerSocialFilesService} from "./banner-social-files.service";
import {BannerSocialFilePathStateService} from "./banner-social-file-path-state.service";
import {BannerSocialFileData} from "../types/banners-social-modal.types";

@Injectable({
  providedIn: 'root'
})
export class BannerSocialFilesSyncService {
  private bannerSocialFilesService: BannerSocialFilesService = inject(BannerSocialFilesService);
  private bannerSocialFilePathStateService: BannerSocialFilePathStateService = inject(BannerSocialFilePathStateService);

  public async updateFilePriority(fileId: number, priority: number): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.bannerSocialFilePathStateService.pathFileState(),
      recordId: fileId,
      fieldName: 'priority',
      value: priority
    };

    await this.bannerSocialFilesService.updatedRecordField<BannerSocialFileData>(params);
  }
}
